'use client';

import { gtmPush } from '@/lib/gtm';
import Image from 'next/image';
import Link from 'next/link';
import { useEffect, useState } from 'react';
import { WHATSAPP_ADQUIRA_HREF } from '@/constants/whatsapp';

type WhatsappProps = {
  link: string;
  page: string;
  interceptAdquira?: boolean;
};

export default function Whatsapp({
  link,
  page,
  interceptAdquira = false,
}: WhatsappProps) {
  const [showLabel, setShowLabel] = useState(true);
  const [labelMounted, setLabelMounted] = useState(true);

  useEffect(() => {
    const fadeTimeout = setTimeout(() => setShowLabel(false), 5000);
    const unmountTimeout = setTimeout(() => setLabelMounted(false), 5500);
    return () => {
      clearTimeout(fadeTimeout);
      clearTimeout(unmountTimeout);
    };
  }, []);

  const wt_onclick = (
    click_location = 'floating_button',
    button_position = 'center_right'
  ) => {
    gtmPush({
      event: 'whatsapp_click',
      click_location,
      button_position,
      page_type: '/institucional/' + page, // página onde ocorreu o clique
    });
  };

  useEffect(() => {
    if (!interceptAdquira) return;

    const onClick = (e: MouseEvent) => {
      const anchor = (e.target as Element | null)?.closest('a');
      if (anchor?.getAttribute('href') !== WHATSAPP_ADQUIRA_HREF) return;

      e.preventDefault();
      wt_onclick('header_adquira', 'header');
      window.open(link, '_blank', 'noopener,noreferrer');
    };

    document.addEventListener('click', onClick, true);
    return () => document.removeEventListener('click', onClick, true);
  }, [interceptAdquira, link, page]);

  const label = labelMounted && (
    <span
      aria-hidden={!showLabel}
      className={`bg-white text-gray-700 text-sm px-5 py-3 rounded-full shadow-lg whitespace-nowrap transition-opacity duration-500 ${
        showLabel ? 'opacity-100' : 'opacity-0 pointer-events-none'
      }`}
    >
      Fale agora com um especialista
    </span>
  );

  const icon = (
    <div className="relative w-16 h-16">
      {!labelMounted && (
        <span className="absolute inset-0 rounded-full bg-[#25D366] animate-whatsapp-ring" />
      )}
      <div className="relative w-16 h-16 rounded-full overflow-hidden shadow-lg hover:scale-110 transition-transform duration-300">
        <Image
          src="/Whatsapp.png"
          alt="Fale conosco pelo WhatsApp"
          width={150}
          height={150}
          className="object-cover"
          priority={false}
        />
      </div>
    </div>
  );

  const wrapperClassName =
    'fixed right-4 bottom-[72px] z-40 flex items-center gap-2';

  return (
    <Link
      href={link}
      onClick={() => wt_onclick()}
      target="_blank"
      rel="noopener noreferrer"
      className={wrapperClassName}
    >
      {label}
      {icon}
    </Link>
  );
}
